import React from "react";
import styles from "./index.module.less";

interface IProps {
  time: string;
}

const Time = ({ time }: IProps) => {
  if (!time) return <span>-</span>;
  const [prefix, suffix] = time.split(" ");

  return (
    <div className={styles.container}>
      {prefix && <div className={styles.prefix}>{prefix}</div>}
      {suffix && <div className={styles.suffix}>{suffix}</div>}
    </div>
  );
};

export default Time;
